<template>
  <div class="mt-3">
    <p class="font-semibold text-xs text-gray-700 dark:text-gray-300 tracking-wide uppercase mb-2">
      {{ I18N.application.bookings.meeting_notes }}
    </p>

    <textarea v-model="notes" rows="4" :disabled="saving"
      class="w-full bg-gray-50 dark:bg-gray-800 border border-gray-200 dark:border-gray-600 rounded-lg px-3 py-2 text-sm text-gray-700 dark:text-gray-200 focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:opacity-60"></textarea>
    <p class="text-xs text-gray-400 mt-1.5">({{ I18N.application.bookings.only_host_see }})</p>

    <div class="mt-3 flex items-center gap-3">
      <button @click="save" :disabled="saving"
        class="flex items-center gap-2 px-4 py-2 bg-blue-600 hover:bg-blue-700 disabled:opacity-50 rounded-lg text-white text-sm font-medium transition-colors">
        <svg v-if="saving" class="w-4 h-4 animate-spin" fill="none" viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"/>
          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 0 1 8-8V0C5.373 0 0 5.373 0 12h4z"/>
        </svg>
        {{ saving ? I18N.application.onboarding.saving : I18N.application.bookings.update }}
      </button>
      <button @click="$emit('close')" :disabled="saving"
        class="text-sm text-gray-500 hover:text-gray-900 dark:text-gray-400 dark:hover:text-white transition-colors">
        {{ I18N.application.events.cancel }}
      </button>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { useConstants } from 'composables/useConstants.js'
import { useEventBookingsStore } from 'stores/eventBookings.js'

const props = defineProps({
  eventId: { type: [String, Number], required: true },
  bookingId: { type: [String, Number], required: true },
  modelValue: { type: String, default: '' },
  flash: { type: Object, default: null },
})
const emit = defineEmits(['update:modelValue', 'close'])

const { I18N } = useConstants()
const store = useEventBookingsStore()

const notes = ref(props.modelValue || '')
const saving = ref(false)

async function save() {
  saving.value = true
  const result = await store.updateInternalNotes(props.eventId, props.bookingId, notes.value)
  saving.value = false

  if (result.success) {
    emit('update:modelValue', notes.value)
    props.flash?.value?.show(result.message || I18N.notifications.booking_updated, 'notice')
    emit('close')
  } else {
    props.flash?.value?.show(result.message, 'alert')
  }
}
</script>
